module.exports = __webpack_public_path__ + "img/gov_logo.f39b4d0d.png";